module.exports = __webpack_public_path__ + "portfolioLabs.fedf3cfbeba7190eefd05da3c08e11f0.png";